export const constructionMaterialCalculationConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_CONSTRUCTION_MATERIAL_CALCULATION_SUCCESS',
		REQUEST : 'GET_PAGED_CONSTRUCTION_MATERIAL_CALCULATION_REQUEST',
		FAILURE : 'GET_PAGED_CONSTRUCTION_MATERIAL_CALCULATION_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_CONSTRUCTION_MATERIAL_CALCULATION_REQUEST',
		SUCCESS : 'CREATE_CONSTRUCTION_MATERIAL_CALCULATION_SUCCESS',
		FAILURE : 'CREATE_CONSTRUCTION_MATERIAL_CALCULATION_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_CONSTRUCTION_MATERIAL_CALCULATION_REQUEST',
		SUCCESS : 'DELETE_CONSTRUCTION_MATERIAL_CALCULATION_SUCCESS',
		FAILURE : 'DELETE_CONSTRUCTION_MATERIAL_CALCULATION_FAILURE'
	},
	DeleteSelected: {
		REQUEST : 'DELETE_CONSTRUCTION_MATERIAL_CALCULATION_SELECTED_REQUEST',
		SUCCESS : 'DELETE_CONSTRUCTION_MATERIAL_CALCULATION_SELECTED_SUCCESS',
		FAILURE : 'DELETE_CONSTRUCTION_MATERIAL_CALCULATION_SELECTED_FAILURE'
	},
	DeleteFiltered: {
		REQUEST : 'DELETE_CONSTRUCTION_MATERIAL_CALCULATION_FILTERED_REQUEST',
		SUCCESS : 'DELETE_CONSTRUCTION_MATERIAL_CALCULATION_FILTERED_SUCCESS',
		FAILURE : 'DELETE_CONSTRUCTION_MATERIAL_CALCULATION_FILTERED_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_CONSTRUCTION_MATERIAL_CALCULATION_REQUEST',
		SUCCESS : 'UPDATE_CONSTRUCTION_MATERIAL_CALCULATION_SUCCESS',
		FAILURE : 'UPDATE_CONSTRUCTION_MATERIAL_CALCULATION_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_CONSTRUCTION_MATERIAL_CALCULATION_REQUEST',
		SUCCESS : 'RESTORE_CONSTRUCTION_MATERIAL_CALCULATION_SUCCESS',
		FAILURE : 'RESTORE_CONSTRUCTION_MATERIAL_CALCULATION_FAILURE'
	},
	UpdateByFile: {
		REQUEST : 'UPDATE_CONSTRUCTION_MATERIAL_CALCULATION_FROM_FILE_REQUEST',
		SUCCESS : 'UPDATE_CONSTRUCTION_MATERIAL_CALCULATION_FROM_FILE_SUCCESS',
		FAILURE : 'UPDATE_CONSTRUCTION_MATERIAL_CALCULATION_FROM_FILE_FAILURE'
	},
	GetExampleFile: {
		SUCCESS : 'GET_EXAMPLE_FILE_CONSTRUCTION_MATERIAL_CALCULATION_SUCCESS',
		REQUEST : 'GET_EXAMPLE_FILE_CONSTRUCTION_MATERIAL_CALCULATION_REQUEST',
		FAILURE : 'GET_EXAMPLE_FILE_CONSTRUCTION_MATERIAL_CALCULATION_FAILURE'
	},
	Clear: 'CLEAR_CONSTRUCTION_MATERIAL_CALCULATION'
}